import { schema } from "normalizr";
import pageSchema from "./page";
import segmentSchema from "./segment";
import audienceSchema from "./audience";
import { generateQuoteKeyFromQuote } from "../modules/results/selectors";

const quoteSchema = new schema.Entity(
    "quotes",
    {
        segmentIds: [segmentSchema],
        audienceId: audienceSchema,
        pageId: pageSchema
    },
    {
        idAttribute: value => generateQuoteKeyFromQuote(value)
    }
);

export default quoteSchema;



// WEBPACK FOOTER //
// ./src/schemas/quote.js